module.exports = __webpack_public_path__ + "static/img/jc1.70e8267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/jc1.png
// module id = HNhv
// module chunks = 1